<ng-container *ngIf="environment$ | async as environment">
  <div class="test_info" *ngIf="environment.showUnderConstructionSign">
    <img class="under-construction" src="assets/icons/common/under-construction.svg" alt="test enviroment"/>
  </div>
</ng-container>
